// ============================================================================
// KOREAN TRANSLATIONS - JESUS IS NOT
// ============================================================================
// 예수님에 대한 신학적 명확화 (포용적 사랑의 강조)

export const jesusIsNotKo = [
  {
    category: "포용성",
    text: "예수님은 인종차별주의자가 아닙니다",
    reference: "요한복음 4:9",
    context: "예수님은 인종과 문화의 장벽을 넘어 사마리아 여인과 대화하셨습니다"
  },
  {
    category: "포용성",
    text: "예수님은 배타적이지 않습니다",
    reference: "마태복음 11:28",
    context: "그분은 모든 사람을 초대하시며, 어떤 진실한 마음도 거부하지 않으십니다"
  },
  {
    category: "사랑",
    text: "예수님은 조건부로 사랑하지 않으십니다",
    reference: "로마서 5:8",
    context: "그분은 우리가 죄인이었을 때 우리를 위해 죽으셨습니다"
  },
  {
    category: "자비",
    text: "예수님은 심판만 하러 오지 않으셨습니다",
    reference: "요한복음 3:17",
    context: "그분의 주요 목적은 세상을 구원하는 것입니다"
  },
  {
    category: "포용성",
    text: "예수님은 한 민족만을 위한 분이 아닙니다",
    reference: "요한복음 10:16",
    context: "그분에게는 모든 민족에서 온 다른 양들이 있습니다"
  },
  {
    category: "접근성",
    text: "예수님은 엘리트를 위한 분이 아닙니다",
    reference: "마가복음 2:17",
    context: "그분은 병든 자, 가난한 자, 소외된 자들과 함께하셨습니다"
  },
  {
    category: "자비",
    text: "예수님은 용서하지 않는 분이 아닙니다",
    reference: "누가복음 23:34",
    context: "십자가 위에서도 그분은 용서하셨습니다"
  },
  {
    category: "사랑",
    text: "예수님은 무관심하지 않으십니다",
    reference: "마태복음 9:36",
    context: "그분은 군중을 보시고 깊이 불쌍히 여기셨습니다"
  },
  {
    category: "포용성",
    text: "예수님은 성차별주의자가 아닙니다",
    reference: "요한복음 20:17",
    context: "그분은 여성들을 존중하시고 그들을 첫 부활의 증인으로 선택하셨습니다"
  },
  {
    category: "자비",
    text: "예수님은 폭력적이지 않으십니다",
    reference: "마태복음 5:39",
    context: "그분은 평화와 비폭력을 가르치셨습니다"
  },
  {
    category: "접근성",
    text: "예수님은 멀리 계시지 않습니다",
    reference: "마태복음 28:20",
    context: "그분은 세상 끝날까지 우리와 함께 하신다고 약속하셨습니다"
  },
  {
    category: "포용성",
    text: "예수님은 한 계층만을 위한 분이 아닙니다",
    reference: "야고보서 2:1-9",
    context: "그분에게는 부자와 가난한 자 사이의 편애가 없습니다"
  },
  {
    category: "사랑",
    text: "예수님은 분노만 하시는 분이 아닙니다",
    reference: "요한복음 13:1",
    context: "그분은 우리를 끝까지 사랑하셨습니다"
  },
  {
    category: "자비",
    text: "예수님은 율법주의적이지 않으십니다",
    reference: "마가복음 2:27",
    context: "사람이 안식일을 위해 있는 것이 아니라, 안식일이 사람을 위해 있다고 말씀하셨습니다"
  },
  {
    category: "포용성",
    text: "예수님은 한 종교 전통에만 속한 분이 아닙니다",
    reference: "요한복음 4:21-24",
    context: "그분은 진리와 영으로 드리는 보편적 예배를 가르치십니다"
  },
  {
    category: "접근성",
    text: "예수님은 복잡한 종교 의식을 요구하지 않으십니다",
    reference: "마태복음 18:3",
    context: "그분은 어린아이 같은 단순한 믿음을 요청하십니다"
  },
  {
    category: "사랑",
    text: "예수님은 원한을 품지 않으십니다",
    reference: "베드로전서 2:23",
    context: "모욕을 당하셨을 때 모욕으로 갚지 않으셨습니다"
  },
  {
    category: "자비",
    text: "예수님은 억압하지 않으십니다",
    reference: "마태복음 11:30",
    context: "그분의 멍에는 쉽고 그분의 짐은 가볍습니다"
  },
  {
    category: "포용성",
    text: "예수님은 나이로 차별하지 않으십니다",
    reference: "마가복음 10:14",
    context: "그분은 어린이들을 환영하시고 노인들을 존중하십니다"
  },
  {
    category: "사랑",
    text: "예수님은 죄인들을 정죄하러 오지 않으셨습니다",
    reference: "요한복음 8:11",
    context: "그분은 간음한 여인에게 '나도 너를 정죄하지 아니하노니'라고 말씀하셨습니다"
  }
];

export default jesusIsNotKo;
